export default "__VITE_ASSET__DTxuinn0__ 320w, __VITE_ASSET__Dvle$bwP__ 480w, __VITE_ASSET__CIXivcBI__ 640w, __VITE_ASSET__C_yKmTFF__ 800w";